import {
  Button,
  Checkbox,
  Divider,
  Header,
  Icon,
  Text,
} from '@wework/dieter-ui'
import { withFloorMap } from '@wework/react-floormap'
import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useSidebar } from '../../hoc/withSidebar'

import Row from '../Common/Row'
import InternalRoomsDrawerFooter from '../InternalRooms/InternalRoomsDrawerFooter'
import LoadingPlaceholder from '../Misc/LoadingPlaceholder'

function InternalRoomsDrawer({
  floorMap,
  space,
  onDeselect,
  deselectAll,
  setSelectedInternalRooms,
  selectedInternalRooms = [],
}: any) {
  const [hasIR, setHasIR] = useState(false)
  const [loading, setLoading] = useState(false)
  const { closeSideBar } = useSidebar()

  useEffect(() => {
    setHasIR(selectedInternalRooms?.length > 0)
    return () => {
      setHasIR(false)
    }
  }, [selectedInternalRooms])

  useEffect(() => {
    if (!floorMap) {
      return
    }
    const inventoryExt = floorMap.getExtension('inventoryData')

    async function fetchHistory() {
      const data = await inventoryExt.getInternals(space.uuid)
      setSelectedInternalRooms(data || [])
      setLoading(false)
    }
    if (inventoryExt && space) {
      setLoading(true)
      fetchHistory()
    }

    return () => {
      setSelectedInternalRooms([])
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [floorMap, space])

  if (!space) {
    return null
  }

  const findDiff = (x, y) => {
    const firstArray = x.filter(o => !y.some(i => i.id === o.id))
    return firstArray
  }

  const save = async () => {
    setLoading(true)
    const inventoryExt = floorMap.getExtension('inventoryData')
    const data = await inventoryExt.getInternals(space.uuid)
    const removedElements = findDiff(data, selectedInternalRooms)
    if (removedElements.length > 0) {
      await inventoryExt.unlinkRooms(
        floorMap.getCurrentFloor().uuid,
        removedElements
      )
    }
    await inventoryExt.linkChildsToParent(
      floorMap.getCurrentFloor().uuid,
      space.uuid,
      selectedInternalRooms
    )

    // update the room data
    floorMap.updateData(space.uuid, {
      ...space,
      metrics: {
        internalRooms: selectedInternalRooms.length,
      },
    })

    setLoading(false)
    closeSideBar()
  }

  return (
    <>
      {loading ? (
        <>
          <LoadingPlaceholder text={'Loading internal rooms'} />
        </>
      ) : (
        <>
          <div
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 6,
            }}
          >
            <Header as="h3" style={{ margin: 0 }}>
              Internal Rooms
            </Header>
            <Button basic onClick={() => closeSideBar()} icon="close" />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'scroll',
              marginBottom: 12,
            }}
          >
            <Text style={{ marginTop: 20 }}>
              Does <b>{space.number}</b> have internal rooms?
            </Text>
            <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
              <Checkbox
                toggle
                checked={hasIR}
                // disabled={loader}
                onChange={(e, data) => {
                  setHasIR(data.checked || false)
                  if (!data.checked) {
                    deselectAll()
                  }
                }}
                // value={option.value}

                color="primary"
              />
              <Text style={{ marginLeft: 8 }}>{hasIR ? 'Yes' : 'No'}</Text>
            </Row>
            {hasIR && (
              <>
                <Divider light />
                {selectedInternalRooms.length > 0 ? (
                  <div
                    style={{
                      display: 'flex',
                      flexFlow: 'wrap',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    {selectedInternalRooms.map((room, index) => {
                      return (
                        <Button
                          size="medium"
                          // primary={multipleSelected}
                          active={true}
                          basic
                          onClick={() => onDeselect(room)}
                          style={{
                            textTransform: 'inherit',
                            borderRadius: 36,
                            display: 'flex',
                            width: 'fit-content',
                            alignItems: 'center',
                            marginTop: 8,
                          }}
                          // disabled={loading && !buildingError && !floorError}
                        >
                          <Text size="small" primary={true}>
                            {
                              //@ts-ignore
                              room.office_number
                            }
                          </Text>

                          <Icon
                            name="close"
                            style={{ marginLeft: 8, color: '#0077CC' }}
                          />
                        </Button>
                      )
                    })}
                  </div>
                ) : (
                  <Button
                    size="medium"
                    basic
                    onClick={() => {}}
                    style={{
                      textTransform: 'inherit',
                      borderRadius: 36,
                      display: 'flex',
                      width: 'fit-content',
                      alignItems: 'center',
                      marginLeft: 4,
                    }}
                  >
                    <Text size="small" color="grey">
                      No room selected
                    </Text>
                  </Button>
                )}
                <Text secondary size="small" style={{ marginTop: 16 }}>
                  Use the map to select all the internal rooms for this space.{' '}
                </Text>
              </>
            )}
          </div>

          <InternalRoomsDrawerFooter
            onClick={save}
            selectionLength={selectedInternalRooms?.length || 0}
          />
        </>
      )}
    </>
  )
}

export default withFloorMap()(InternalRoomsDrawer)
